export const doesPhoneTypeMatchSearch = (type: string, search: string) =>
  !search.length || type.toLowerCase().includes(search.toLowerCase());
